import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Header, MyProfilesList, Title, Breadcrumbs } from "../../../components";

import { useAppDispatch } from "../../../redux/store";
import { setSubscrFormsData } from "../../../redux/subscriptions/slice";

import styles from "./SubscriptionsProfiles.module.scss";

import { SubscrProfilesPropsType } from "./types";
import { ISubscrFormData } from "../../../redux/subscriptions/types";
import { IMyprofile } from "../../../redux/profile/profileInfo/types";
import { getSubscrFormsDataFromStorage } from "../../../utils";

export const SubscriptionsProfiles: React.FC<SubscrProfilesPropsType> = ({ title }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const locationState = location.state as 
    | { formData: ISubscrFormData } 
    | { profileId: string; profileType: string; profileNumber: number; returnPath?: string }
    | null;
  
  const formData = (locationState as { formData?: ISubscrFormData })?.formData;
  const profileId = (locationState as { profileId?: string })?.profileId;
  const profileType = (locationState as { profileType?: string })?.profileType;
  const returnPath = (locationState as { returnPath?: string })?.returnPath;

  React.useEffect(() => {
    const subscrFormsData = getSubscrFormsDataFromStorage();

    if (subscrFormsData) {
      subscrFormsData.forEach((item: ISubscrFormData) =>
        dispatch(setSubscrFormsData(item))
      );
    } // eslint-disable-next-line
  }, []);

  const handleSelectProfile = (profileData: IMyprofile) => {
    if (profileId) {
      return;
    }
    
    if (!formData) return;
    
    formData.profileValues.name = profileData.name;
    if (profileData.phone) formData.profileValues.secondaryText = profileData.phone;
    if (profileData.birthday) formData.profileValues.secondaryText = profileData.birthday;
    formData.profileValues.id = profileData.id;
    formData.profileValues.elKey = profileData.user_id;

    dispatch(setSubscrFormsData(formData));
    navigate("/subscriptions-forms");
  };

  if (!formData && !profileId) {
    navigate("/subscriptions-forms");
    return null;
  }

  const getFilterType = () => {
    if (profileType) {
      return profileType === "child" ? "kid" : profileType === "adult" ? "adult" : undefined;
    }
    
    if (formData) {
      if (formData.subscrData.type === "family") {
        return formData.type || undefined;
      } else {
        return formData.subscrData.type === "adult" ? "adult" : 
               formData.subscrData.type === "kid" ? "kid" : 
               undefined;
      }
    }
    
    return undefined;
  };

  return (
    <>
      <Header title={title} />
      <main>
        <div className="container">
          <Breadcrumbs />
        </div>
        <section className="container">
          <Title>{title}</Title>
          <div className={styles.wrapper}>
            <div className={styles.profileList}>
              <MyProfilesList
                onPage={profileId ? "profile" : "payment"}
                selectFunc={handleSelectProfile}
                filterType={getFilterType()}
              />
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
